import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import 'react-grid-layout/css/styles.css';
// Sentry.init must run before ./App → routes/index.tsx builds the router at
// module scope — wrapCreateBrowserRouter depends on init side effects
// (sentry-javascript#16062). Import order is load-bearing, not style.
import './lib/monitoring/sentry';
import './lib/monitoring/clarity';
import App from './App';
import {
  clearStaleChunkReloadFlag,
  STALE_CHUNK_FLAG_CLEAR_DELAY_MS,
} from './lib/chunk-load-error';
import { registerServiceWorker } from './lib/registerServiceWorker';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

window.setTimeout(() => {
  clearStaleChunkReloadFlag();
}, STALE_CHUNK_FLAG_CLEAR_DELAY_MS);

// PWA shell worker — production-only; skipped under `vite dev`.
registerServiceWorker();
